import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import { MultilangEditModalComponent } from '../multilang-edit-modal.component';
import { BlockEditModalComponent } from './block-edit-modal.component';

import { NbDialogService, NbMenuService } from '@nebular/theme';

import { map, filter } from 'rxjs/operators';

import { IdTools } from '../../../utils/id-tools';

@Component({
    selector: 'app-block-editor',
    templateUrl: './block-editor.component.html',
    styleUrls: ['./block-editor.component.scss'],
    standalone: false
})
export class BlockEditorComponent implements OnInit {

  originalModel;
  _model;
  @Input() set model(model){
    this._model = model;
    this.isStructuredModel();
    this.originalModel = {...model};
  };
  @Input() game;
  @Input() template;
  @Input() missionId;
  @Input() languages;
  @Input() defaultLang;
  @Input() characters;
  @Input() voices;
  @Input() templateVoices;
  @Input() editMode = true;
  @Input() htmlMode = true;

  //for template comparison
  @Input() attribute;
  @Input() templateModel;
  @Input() showApplyChanges;

  _changes
  @Input() set changes(changes){
    //console.log('set changes:'+JSON.stringify(changes));
    this._changes = changes;
    if(changes) this.checkForChanges();
  };
  changeCount = 0;
  
  templateDiff;
  checkForChanges(){
    this.changeCount = 0;
    for (let i = 0; i < this._changes.length; i++) {
      if(this.attribute === this._changes[i].fieldName && this._changes[i].languages){
        this.templateDiff = true;
        this.changeCount++;
      }
    }
    //console.log('this.didChange:'+JSON.stringify(this.didChange));
  }

  isStructuredBlock;

  newBlockType = 'text';

  @Output() modelUpdate = new EventEmitter();
  @Output() applyChanges = new EventEmitter();
  @Output() updateFromTemplate = new EventEmitter();

  applyMenu = [
    { title: 'Apply selected language(s)' },
    { title: 'Apply all languages' }
  ]

  constructor(private router: Router,
    private dialogService: NbDialogService,
    private menuService: NbMenuService) {

      this.menuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === ('multilang-editor'+this.attribute)),
        map(({ item: { title } }) => title),
      )
      .subscribe(title => {
        console.log('onItemClick:'+title);
        if(title == 'Apply selected language(s)'){
          this.applyChanges.emit('selected');
        }
        if(title == 'Apply all languages'){
          this.applyChanges.emit('all');
        }
      });
  }

  ngOnInit() {
  }

  isStructuredModel(){
    
    console.log('isStructuredModel:'+this._model);
    //classic text block: {en:'', fr:'', nl:''}
    /*struct block: 
    {
      time: 1679494355708,
      blocks: [
        {
        id: "mhTl6ghSkV",
        type: "paragraph",
        data: {
        text: "Hey. Meet the new Editor. On this picture you can see it in action. Then, try a demo 🤓",
        } ,
      }
    */
    if(this._model && this._model.blocks){
      this.isStructuredBlock = true;
    }
    else{
      this.isStructuredBlock = false;
    }
  }

  switchElement(block){
    if(block.type == 'text'){
      block.type = 'dialog';
      block.data = {text: block.data};
    }
    else{
      block.type = 'text';
      block.data = block.data.text;
    }
    this.save();
  }

  switchMode(){
    this.isStructuredBlock = !this.isStructuredBlock;
    console.log('Switch mode to:'+this.isStructuredBlock);
    if(this.isStructuredBlock){
      let oldModel = {...this._model};
      this._model = this.initBlockStruct();
      let block = this.createBlock('text');
      block.data = oldModel;
      this._model.blocks.push(block);

    }
    else{
      if(this._model.blocks){
        let textFound = false;
        for(let block of this._model.blocks){
          if(block.type == 'text'){
            console.log('Found text block, replace model with:'+JSON.stringify(block.data));
            this._model = block.data;
            textFound = true;
            break;
          }
          if(block.type == 'dialog' && block.data.text){
            console.log('Found dialog block, replace model with:'+JSON.stringify(block.data.text));
            this._model = block.data.text;
            textFound = true;
            break;
          }
        }
        if(!textFound){
          this._model = {};
        }
      }
      else{
        this._model = {};
      }
    }
    this.save();
  }

  initBlockStruct(){
    return {
      time: new Date().getTime(),
      blocks: []
    }
  }

  addBlock(type){
    this._model.blocks.push(this.createBlock(type || this.newBlockType));
    this.editBlock(this._model.blocks.length-1);
  }

  createBlock(type){
    return {
      id: IdTools.makeIdAllChars(10),
      type: type,
      data: {
        //text: "Hey. Meet the new Editor. On this picture you can see it in action. Then, try a demo 🤓",
      }
    }
  }

  duplicateBlock(index){
    let block = JSON.parse(JSON.stringify(this._model.blocks[index]));
    block.id = IdTools.makeIdAllChars(10);
    this._model.blocks.splice(index+1, 0, block);
    this.save();
  }

  editBlock(index){
    event.stopPropagation();
    this.dialogService.open(BlockEditModalComponent, { 
      context: {
        model: this._model.blocks[index],
        gameId: this.game?.id,
        templateId: this.template?.id,
        defaultLang: this.defaultLang,
        htmlMode: this.htmlMode,
        languages: this.languages
      }, dialogClass: 'modal-full', closeOnBackdropClick: false
    })
    .onClose.subscribe(res => {
      console.log('Dialog returns:'+JSON.stringify(res));
      if(res){
        this.save();
      }
    });
  }

  async changePosition(old_index, new_index){
    let block1 = this._model.blocks[old_index];
    this._model.blocks[old_index] = this._model.blocks[new_index];
    this._model.blocks[new_index] = block1;
    this.save();
    //await this.characterService.updateCharacter(this._model, {moods: this._model.moods});
  }

  deleteBlock(index){
    this._model.blocks.splice(index, 1);
    this.save();
  }

  editText(block, htmlMode = true){
    event.stopPropagation();
    this.dialogService.open(MultilangEditModalComponent, { 
      context: {
        model: block ? (block.data ? block.data : {}) : this._model,
        editMode: true,
        defaultLang: this.defaultLang ? this.defaultLang : null,
        htmlMode: htmlMode,
        languages: this.languages
      }, closeOnBackdropClick: false
    })
    .onClose.subscribe(res => {
      console.log('Dialog returns:'+JSON.stringify(res));
      if(res){
        if(block){
          block.data = res;
          this.save();
        }
        else{
          this._model = res;
          this.modelUpdate.emit(this._model);
          console.log('New model:'+JSON.stringify(this._model));
        }
      }
    });
  }

  save(){
    if(this.isStructuredBlock){
      this._model.time = new Date().getTime();
    }
    this.modelUpdate.emit(this._model);
  }

  rollback(){
    this._model = this.originalModel;
    this.isStructuredModel();
  }

  updateFieldFromTemplate(){
    this.updateFromTemplate.emit();
  }

}
